<!-- モーダルオーバーレイ -->
<div class="modal-overlay" *ngIf="isOpen" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- ヘッダー -->
    <div class="modal-header">
      <h3>{{ title }}</h3>
      <button class="close-button" (click)="close()" aria-label="Close">×</button>
    </div>

    <!-- 本文 -->
    <div class="modal-body">
      <ng-content></ng-content>
    </div>

    <!-- フッター -->
    <div class="modal-footer">
      <button class="spectrum-button spectrum-button--secondary" (click)="close()">Close</button>
    </div>
  </div>
</div>
